import React, { forwardRef } from "react";
import serjusHeader from "../../assets/header-contrato/header-contrato.png";

const CartaTrayectoriaInstitucional = forwardRef(({ data }, ref) => {
    const fechaObj = data.fecha
        ? (() => {
            const [anio, mes, dia] = data.fecha
                .split("-")
                .map(Number);

            return new Date(anio, mes - 1, dia);
        })()
        : new Date();
    const dia = fechaObj.getDate();
    const mes = fechaObj.toLocaleDateString("es-GT", {
        month: "long",
    });
    const anio = fechaObj.getFullYear();
    return (
        <>
            <style>{`
        @page { margin: 1.5cm; }

        body, p {
          font-family: 'Arial Narrow', Arial, sans-serif !important;
          font-size: 12pt !important;
          line-height: 1.3 !important;
        }

        #lineprintable,
        #printable {
            font-family: "Times New Roman", serif;
            font-size: 11pt;
            line-height: 1.6;
            text-align: justify;
        }

        #printable p {
            margin: 0 0 8pt 0;
        }

        #printable h1 {
            font-size: 14pt;
            margin-bottom: 18pt;
        }

        .input-field {
          background-color: rgba(255, 215, 0, 0.6);
          border-bottom: 1px solid #FFD700;
          padding: 0 2px;
        }

        @media print {
          .input-field {
            background: none !important;
            border: none !important;
            box-shadow: none !important;
          }
        }

        .input-field:empty {
            background-color: rgba(255,215,0,.6);
        }
      `}</style>

            <div style={pageStyle}>
                <div
                    id="printable"
                    ref={ref}
                    style={{
                        minHeight: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* Encabezado */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <img
                            src={serjusHeader}
                            alt="SERJUS"
                            style={{
                                width: "100%",
                                maxHeight: "110px",
                                objectFit: "contain",
                            }}
                        />
                    </div>

                    <h1
                        style={{
                            textAlign: "center",
                            marginBottom: "25px",
                        }}
                    >
                        RECONOCIMIENTO A LA TRAYECTORIA INSTITUCIONAL
                    </h1>

                    <p>
                        Asociación Comunitaria para el Desarrollo SERJUS,
                        ASERJUS, expresa su profundo agradecimiento y
                        reconocimiento a:
                    </p>

                    <p>
                        <span className="input-field">
                            {data.nombreEmpleado || "________________________________"}
                        </span>
                        {" - "}
                        <span className="input-field">
                            {data.puesto || "____________________________"}
                        </span>
                    </p>

                    <p style={{ marginTop: "25px" }}>
                        Por sus{" "}
                        <span className="input-field">
                            {data.aniosServicio || "____"}
                        </span>{" "}
                        años de servicio, compromiso y aporte institucional.
                    </p>

                    <p>
                        Durante este tiempo ha contribuido con
                        responsabilidad, entrega y vocación al trabajo
                        comunitario y al cumplimiento de los principios y
                        objetivos institucionales.
                    </p>

                    <p>
                        Su trayectoria representa un valioso aporte humano
                        y profesional para nuestra organización.
                    </p>

                    <p style={{ marginTop: "30px" }}>
                        En constancia de nuestro reconocimiento y gratitud,
                        se extiende el presente documento en la ciudad de{" "}
                        <span className="input-field">
                            {data.ciudad || "Quetzaltenango"}
                        </span>
                        , a los{" "}
                        <span className="input-field">
                            {dia || "____"}
                        </span>{" "}
                        días del mes de{" "}
                        <span className="input-field">
                            {mes || "________________"}
                        </span>{" "}
                        del año{" "}
                        <span className="input-field">
                            {anio || "______"}
                        </span>
                        .
                    </p>

                    {/* Firma */}
                    <div
                        style={{
                            marginTop: "60px",
                            textAlign: "center",
                        }}
                    >
                        <p>
                            <span
                                style={{
                                    marginTop: "100px",
                                    textAlign: "center",
                                }}
                            >
                                Firma: ________________________
                            </span>
                            <br />
                            <span className="input-field">
                                {data.nombreResponsable ||
                                    "____________________________"}
                            </span>
                            <br />
                            <span className="input-field">
                                {data.cargoResponsable ||
                                    "____________________________"}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
});

const pageStyle = {
    width: "100%",
    background: "#fff",
    margin: 0,
    padding: "0 0 0 30px",
    boxSizing: "border-box",
};

export default CartaTrayectoriaInstitucional;